/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlytzcollectAnalyticsRouteImport } from './routes/blytzcollect/analytics'
import { Route as BlytzcollectFunnelRouteImport } from './routes/blytzcollect/funnel'
import { Route as PaymentsAchReturnsRouteImport } from './routes/payments/ach-returns'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlytzcollectAnalyticsRoute = BlytzcollectAnalyticsRouteImport.update({
  id: '/blytzcollect/analytics',
  path: '/blytzcollect/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const BlytzcollectFunnelRoute = BlytzcollectFunnelRouteImport.update({
  id: '/blytzcollect/funnel',
  path: '/blytzcollect/funnel',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsAchReturnsRoute = PaymentsAchReturnsRouteImport.update({
  id: '/payments/ach-returns',
  path: '/payments/ach-returns',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/blytzcollect/analytics': typeof BlytzcollectAnalyticsRoute
  '/blytzcollect/funnel': typeof BlytzcollectFunnelRoute
  '/payments/ach-returns': typeof PaymentsAchReturnsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/blytzcollect/analytics': typeof BlytzcollectAnalyticsRoute
  '/blytzcollect/funnel': typeof BlytzcollectFunnelRoute
  '/payments/ach-returns': typeof PaymentsAchReturnsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/blytzcollect/analytics': typeof BlytzcollectAnalyticsRoute
  '/blytzcollect/funnel': typeof BlytzcollectFunnelRoute
  '/payments/ach-returns': typeof PaymentsAchReturnsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/blytzcollect/analytics'
    | '/blytzcollect/funnel'
    | '/payments/ach-returns'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/blytzcollect/analytics'
    | '/blytzcollect/funnel'
    | '/payments/ach-returns'
  id:
    | '__root__'
    | '/'
    | '/blytzcollect/analytics'
    | '/blytzcollect/funnel'
    | '/payments/ach-returns'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BlytzcollectAnalyticsRoute: typeof BlytzcollectAnalyticsRoute
  BlytzcollectFunnelRoute: typeof BlytzcollectFunnelRoute
  PaymentsAchReturnsRoute: typeof PaymentsAchReturnsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blytzcollect/analytics': {
      id: '/blytzcollect/analytics'
      path: '/blytzcollect/analytics'
      fullPath: '/blytzcollect/analytics'
      preLoaderRoute: typeof BlytzcollectAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blytzcollect/funnel': {
      id: '/blytzcollect/funnel'
      path: '/blytzcollect/funnel'
      fullPath: '/blytzcollect/funnel'
      preLoaderRoute: typeof BlytzcollectFunnelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/ach-returns': {
      id: '/payments/ach-returns'
      path: '/payments/ach-returns'
      fullPath: '/payments/ach-returns'
      preLoaderRoute: typeof PaymentsAchReturnsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BlytzcollectAnalyticsRoute: BlytzcollectAnalyticsRoute,
  BlytzcollectFunnelRoute: BlytzcollectFunnelRoute,
  PaymentsAchReturnsRoute: PaymentsAchReturnsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
